// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_DW6FF {
  display: grid;
  grid-template-columns: 70% calc(30% - 3px);
  column-gap: 3px;
  row-gap: var(--size-padMedium);
  width: 100%;
  align-items: start;
  justify-items: start;
}

.flex_qb46Z {
  overflow: hidden;
}

.hr_InLSo {
  border: none;
  border-bottom: 1px solid var(--color-base200);
}

.grow_gS45O {
  flex-grow: 1;
}

.overrides__6maW {
  min-width: 350px;
}

.titleBump_P4hzB {
  padding: var(--size-padMedium);
}

.verticalGridCell_NSeHQ:not(:last-child) {
  border-right: 1px solid var(--color-base100);
}

.tab_SCg2d {
  padding: var(--size-padMedium);
}

.verticalGridCell_NSeHQ {
  padding: var(--size-padLarge);
}

@media only screen and (max-width: 768px) {
  .overrides__6maW {
    width: auto;
    flex-grow: 1;
    padding: var(--size-padMedium);
    min-width: auto;
  }

  .flex_qb46Z {
    flex-wrap: wrap !important;
    overflow: visible;
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-operating-hours/lib/OperatingHoursEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0CAA0C;EAC1C,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;AACF","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 70% calc(30% - 3px);\n  column-gap: 3px;\n  row-gap: var(--size-padMedium);\n  width: 100%;\n  align-items: start;\n  justify-items: start;\n}\n\n.flex {\n  overflow: hidden;\n}\n\n.hr {\n  border: none;\n  border-bottom: 1px solid var(--color-base200);\n}\n\n.grow {\n  flex-grow: 1;\n}\n\n.overrides {\n  min-width: 350px;\n}\n\n.titleBump {\n  padding: var(--size-padMedium);\n}\n\n.verticalGridCell:not(:last-child) {\n  border-right: 1px solid var(--color-base100);\n}\n\n.tab {\n  padding: var(--size-padMedium);\n}\n\n.verticalGridCell {\n  padding: var(--size-padLarge);\n}\n\n@media only screen and (max-width: 768px) {\n  .overrides {\n    width: auto;\n    flex-grow: 1;\n    padding: var(--size-padMedium);\n    min-width: auto;\n  }\n\n  .flex {\n    flex-wrap: wrap !important;\n    overflow: visible;\n    height: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_DW6FF`,
	"flex": `flex_qb46Z`,
	"hr": `hr_InLSo`,
	"grow": `grow_gS45O`,
	"overrides": `overrides__6maW`,
	"titleBump": `titleBump_P4hzB`,
	"verticalGridCell": `verticalGridCell_NSeHQ`,
	"tab": `tab_SCg2d`
};
export default ___CSS_LOADER_EXPORT___;
